module.exports = __webpack_public_path__ + "static/media/car-alt.21f7412c.svg";